module.exports = __webpack_public_path__ + "static/img/04910658.54f1234f.png";